var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { useDispatch } from 'react-redux';
export const Div1SwitcherComponent = () => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [activeDiv1, setActiveDiv1] = useState('usd');
    const [DIV1, setDIV1] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.VALUE_TYPE1)
            .then((saved) => {
            if (!saved)
                return;
            const clean = String(saved).toLowerCase();
            setActiveDiv1(clean);
        })
            .catch(() => { });
    }, []);
    useEffect(() => {
        const fetchCurrencies = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch('https://timeapp.foundation/divlist.php');
                const data = yield response.json();
                //  // console.log("[TEST] props: " + JSON.stringify(data, null, 2));
                const currencyObj = data[0];
                const list = Object.keys(currencyObj).map(key => ({
                    key: key.toLowerCase(),
                    name: currencyObj[key].trim()
                }));
                setDIV1(list);
                setLoading(false);
            }
            catch (err) {
                //    console.error('Errore caricamento divise', err);
                setLoading(false);
            }
        });
        fetchCurrencies();
    }, []);
    const selectDiv1 = (div1Key) => __awaiter(void 0, void 0, void 0, function* () {
        const lowerKey1 = div1Key.toLowerCase();
        setActiveDiv1(lowerKey1);
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.VALUE_TYPE1, lowerKey1);
        setIsOpen(false);
    });
    if (loading || DIV1.length === 0) {
        return (React.createElement("div", { className: "blockchain-switcher" },
            React.createElement("span", { className: "chain-name" }, "Loading...")));
    }
    const current = DIV1.find(c => c.key === activeDiv1) || DIV1[0];
    return (React.createElement("div", { className: "blockchain-switcher", onClick: () => setIsOpen(!isOpen) },
        React.createElement("span", { className: "chain-name" },
            " ",
            current.key,
            " "),
        React.createElement("span", { className: "currency-name" },
            " ",
            current.name),
        React.createElement("svg", { className: `dropdown-arrow ${isOpen ? 'open' : ''}`, viewBox: "0 0 24 24" },
            React.createElement("path", { d: "M7 10l5 5 5-5z", fill: "currentColor" })),
        isOpen && (React.createElement("div", { className: "dropdown-menu", onClick: (e) => e.stopPropagation() }, DIV1.map((div1) => (React.createElement("div", { key: div1.key, onClick: () => selectDiv1(div1.key) },
            React.createElement("span", { className: "currency-code" }, div1.key),
            React.createElement("span", { className: "currency-name" }, div1.name),
            div1.key === activeDiv1 && React.createElement("span", { className: "check" }, "\u2713"))))))));
};
